import * as React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import Linkify from 'linkifyjs/react';

export interface NoteProps {
  id: string;
  body: string;
  senderTag: string;
  senderId: string;
  senderType: string;
  sentAt: number;
  show?: boolean;
}

export const Note = ({
  id, body,
  senderType, senderId, senderTag,
  sentAt, show = true,
}: NoteProps) => (
  <div
    id={`AvoNote-${id}`}
    className={classNames('note-box', 'out', { hide: !show })}
    data-user-id={senderType === 'User' ? senderId : null}
  >
    <div className="note-body"><Linkify>{body}</Linkify></div>
    <div className="note-timestamp">
      {senderTag && `${senderTag} - `}
      {moment(sentAt).format('L [AT] LT')}
    </div>
  </div>
);
